import React from 'react';
import { Avatar, CustomTheme, SxProps, useTheme } from '@mui/material';
import { ROUTES } from '@routes/routes';
import { IMemberAvatar } from './interface';

export const MemberAvatar: React.FC<IMemberAvatar> = ({
  slug,
  name,
  size = 'normal',
  sx,
}): JSX.Element => {
  const theme = useTheme<CustomTheme>();

  let sizeSx: SxProps = {};

  if (size === 'small') {
    sizeSx = {
      width: '25px',
      height: '25px',
    };
  }

  return (
    <Avatar
      variant="circular"
      alt={name}
      src={ROUTES.images.avatar(slug)}
      sx={{
        display: 'block',
        objectFit: 'cover',
        alignContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        // border: `2px solid ${theme.palette.primary.main}`,
        background: '#BDBDBD',
        ...sizeSx,
        ...sx,
      }}
    />
  );
};
